export default __webpack_public_path__ + "static/media/c++.c4a42e13.svg";